// extracted by mini-css-extract-plugin
module.exports = {"cardMention":"CommentMention_cardMention__1Lvl0","modalMention":"CommentMention_modalMention__7EvE1"};